import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Vimeo from "@u-wave/react-vimeo";
import {
  createItemGen,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  iconUrl,
  isFirstLogIn,
  isUserLoggedIn,
  isBasicPreassessmentDone,
  setProfileData,
} from "../../common/services";

import Navbar from "../../components/CustomNav/CustomNav.Component";

import {
  Container,
  FormWrapper,
  Row,
  ContentWrapper,
  ContentHeading,
  ContentBody,
  VideoWrapper,
} from "../Onboard/Common/Common.styles";

import "./preassessmentGuide.css";
import withServices from "src/HOCs/withServices";
import { toast } from "react-toastify";
import VideoPlayer from "src/components/VideoPlayer/VideoPlayer";

interface IProps {
  services?: any;
  history?: any;
}

const vimeoVar = "students_assess_guide";

class StudentPreAssessmentGuide extends Component<IProps> {
  public state = {
    destination: "",
    toLogin: false,
    navigate: false,
    currentuser: currentUser(),
    assessmentAvailable: false,
    assessmentID: null,
    vimeoID: "",
    loaded: false,
  };
  constructor(props) {
    super(props);
    this.toLogin = this.toLogin.bind(this);
    this.toHelpCenter = this.toHelpCenter.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.toProfile = this.toProfile.bind(this);
    this.startAssessment = this.startAssessment.bind(this);
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }
  public toLogin() {
    this.setState({ navigate: true, destination: "/login" });
  }

  public toProfile() {
    this.setState({ destination: currentBaseUrl + "/profile", navigate: true });
  }

  public toHelpCenter() {
    this.setState({ destination: "/helpcenter", navigate: true });
  }

  public startAssessment = () => {
    // alert("Parent Assessment");
    const { assessmentAvailable, assessmentID } = this.state;
    if (assessmentAvailable) {
      this.props.history.replace(
        `${currentBaseUrl()}assessment/${assessmentID}`
      );
    } else {
      if (!isBasicPreassessmentDone()) {
        toast.info(
          "We are generating your assessment, log back in 5 five minutes"
        );
        window.location.reload();
      } else {
        toast.info("You don't have an assessment at the moment");
        setTimeout(() => {
          this.props.history.replace(`${currentBaseUrl()}home`);
        }, 1000);
      }
    }
  };

  public async componentDidMount() {
    const {
      services: { adminAPI },
    } = this.props;
    if (!isUserLoggedIn()) {
      this.toLogin();
    } else {
      const [assessmentRes, vimeoIDRes] = await Promise.all([
        adminAPI.getNextAssessment(),
        adminAPI.fetchVimeoSystemVar(vimeoVar),
      ]);
      if (assessmentRes.ok) {
        const assessmentInfo = assessmentRes.data;
        const vimeoID = vimeoIDRes.data.value;
        if (assessmentInfo.status === "available") {
          this.setState({
            assessmentAvailable: true,
            assessmentID: assessmentInfo.assessment_id,
            vimeoID,
            loaded: true,
          });
        } else {
          if (isBasicPreassessmentDone()) {
            this.setState({
              assessmentAvailable: false,
              toDashboard: true,
              vimeoID,
              loaded: true,
            });
          } else {
            this.setState({
              assessmentAvailable: false,
              toDashboard: false,
              vimeoID,
              loaded: true,
            });
          }
        }
      }
    }
  }

  public renderVimeo = () => {
    const { vimeoID, loaded } = this.state;

    if (loaded) {
      return (
        <VideoWrapper width="100%">
          <VideoPlayer videoId={vimeoID} width="582px" />
        </VideoWrapper>
      );
    } else {
      return <div />;
    }
  };
  public logoClick = () => {
    return;
  };

  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <Container>
        <Navbar onLogoClick={this.logoClick} logoutParent={this.onLogout} />
        <div
          style={{
            width: "100%",
            height: "90%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Row width="80%">
            <ContentWrapper>
              <ContentHeading color="#acff24">
                WELCOME TO PERFORMANCE LEARNING
              </ContentHeading>
              <ContentBody textAlign="center">
                <span>Meet PLOA</span> <br />
                PLOA is Performance Learning’s side-kick. An intelligent,
                intuitive set of questions designed to get to know you. When you
                answer each question, be yourself and take as much as time as
                you need.
              </ContentBody>
              <button
                className="green-button start-assess"
                onClick={this.startAssessment}
              >
                START ASSESSMENT
              </button>
            </ContentWrapper>

            <FormWrapper width="50%">{this.renderVimeo()}</FormWrapper>
          </Row>
        </div>
      </Container>
    );
  }
}

export default withServices(StudentPreAssessmentGuide);



// WEBPACK FOOTER //
// ./src/pages/Onboarding/StudentPreAssessmentGuide.Component.tsx